import { api } from "@/lib/api";

const KEY = "ct_poster";
const DAYS = 7;

export function capturePosterScan(search) {
  const p = new URLSearchParams(search);
  if (p.get("src") !== "poster") return;
  const place = (p.get("place") || "").slice(0, 40);
  if (sessionStorage.getItem("ct_poster_seen") === place) return;
  sessionStorage.setItem("ct_poster_seen", place);
  localStorage.setItem(KEY, JSON.stringify({ place: place || "(no location)", at: Date.now() }));
  api.post("/posters/scan", { place }).catch(() => {});
}

export function posterPlace() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && Date.now() - v.at < DAYS * 86400000 ? v.place : null;
  } catch {
    return null;
  }
}

export const clearPosterPlace = () => localStorage.removeItem(KEY);
